import { useEffect, useState } from "react";

export const ScoreCard = ({ eventId, sportId }) => {
    const [width, setwidth] = useState()
    useEffect(() => {
        const handleMessage = (event) => {
            if (event.origin !== 'https://nextscore.9xxbet.com') return;
            setwidth(event.data.width)
        };

        window.addEventListener('message', handleMessage);

        return () => {
            window.removeEventListener('message', handleMessage);
        };
    }, []);
    return (
        <div style={{ height: '100%' }} id='__LIVESCOREURL' className=" scorecard-banner">
            {/* <img src={scoreImage} alt="" /> */}
            <iframe style={{ height: `${width}px` }} id="scoreframe" className="w-full h-full flex-grow no-scrollbar" src={'https://nextscore.9xxbet.com/' + "?eventId=" + eventId + "&sportId=" + sportId} width="100%"></iframe>
        </div>
    )
}
